module.exports = __webpack_public_path__ + "static/logo-d426a3e03ff618c138ecf0db6ce6ef3f.png";